// Extend the Window interface to include __pendingReactElements
declare global {
  interface Window {
    __pendingReactElements?: Array<{ element: HTMLElement; type: any; props: any }>;
    renderReact: (element: HTMLElement, type: any, props: any) => void;
  }
}

export const renderPendingReactElements = (render): void => {
  if (typeof window !== "undefined" && window.__pendingReactElements) {
      window.__pendingReactElements.forEach(({element, type, props}) => render(element, type, props));
  }

}

export const renderReactGlobalSnippet  = (): string => {
  return `<script>
      window.renderReact = function renderReact(element, type, props) {
          if (typeof window.__renderReact === "function") {
              window.__renderReact(element, type, props);
          } else {
              window.__pendingReactElements = window.__pendingReactElements = [];
              window.__pendingReactElements.push({element, type, props});
          }
      }
  </script>`;
}